export const API_BASE_URL = (idAds: string) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/advertisements/reserve/${idAds}`;

export const API_BASE_URL_ORGANISM = (idAds: string) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/advertisements/collective/reservation`;

export const API_BASE_URL_ADS = (studentId: string) =>
  `${process.env.REACT_APP_API_URL_RESSOURCES}/advertisements/?studentId=${studentId}`;
